import {REFRESH_ROBOT_BATTERIES_SUCCESS} from "../../../reducers/dashboardReducer";



export const refreshRobotBatteriesSuccess = (processId) =>{
    return {
        type: REFRESH_ROBOT_BATTERIES_SUCCESS,
        payload: {processId}
    }
}